/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Link_Target_NewtabInputs */

const en_enum_link_target_newtab = /** @type {(inputs: Enum_Link_Target_NewtabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in new tab`)
};

const de_enum_link_target_newtab = /** @type {(inputs: Enum_Link_Target_NewtabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In neuem Tab öffnen`)
};

/**
* | output |
* | --- |
* | "Open in new tab" |
*
* @param {Enum_Link_Target_NewtabInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_link_target_newtab = /** @type {((inputs?: Enum_Link_Target_NewtabInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Link_Target_NewtabInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_link_target_newtab(inputs)
	return de_enum_link_target_newtab(inputs)
});